import { Link, useForm } from '@inertiajs/react'
import Seo from '../../components/Seo'
import { useShared } from '../../lib/hooks'

export default function Login({ return_to }: { return_to?: string | null }) {
  const { errors } = useShared()
  const form = useForm({ user: { email: '', password: '', remember_me: true }, return_to: return_to ?? '' })
  const registerHref = return_to ? `/register?return_to=${encodeURIComponent(return_to)}` : '/register'

  function submit(e: React.FormEvent) {
    e.preventDefault()
    form.post('/login')
  }

  return (
    <>
      <Seo title="Sign in" noindex />
      <div className="mx-auto max-w-md px-4 sm:px-6 py-16">
        <div className="mono-label mb-3">Account</div>
        <h1 className="text-3xl font-semibold tracking-tight">Sign in</h1>
        <p className="mt-2 text-muted text-sm">Sign in to check out and download your packs.</p>

        {errors?.email && (
          <div className="mt-6 rounded-md border border-red-500/40 bg-red-500/10 text-red-300 px-4 py-2.5 text-sm">
            {errors.email}
          </div>
        )}

        <form onSubmit={submit} className="mt-6 space-y-4">
          <Field
            label="Email"
            type="email"
            autoComplete="email"
            value={form.data.user.email}
            onChange={(v) => form.setData('user', { ...form.data.user, email: v })}
            required
          />
          <Field
            label="Password"
            type="password"
            autoComplete="current-password"
            value={form.data.user.password}
            onChange={(v) => form.setData('user', { ...form.data.user, password: v })}
            required
          />

          <button
            type="submit"
            disabled={form.processing}
            className="w-full h-12 bg-paper text-ink text-sm font-semibold hover:opacity-90 transition disabled:opacity-60"
          >
            {form.processing ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="mt-4 text-sm text-muted">
          <Link href="/password/new" className="text-paper hover:underline">Forgot your password?</Link>
        </p>

        <p className="mt-6 text-sm text-muted">
          No account?{' '}
          <Link href={registerHref} className="text-paper hover:underline">Create one</Link>
        </p>
      </div>
    </>
  )
}

function Field({
  label,
  type,
  value,
  onChange,
  autoComplete,
  required,
}: {
  label: string
  type: string
  value: string
  onChange: (v: string) => void
  autoComplete?: string
  required?: boolean
}) {
  return (
    <label className="block">
      <span className="mono-label">{label}</span>
      <input
        type={type}
        value={value}
        autoComplete={autoComplete}
        required={required}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1.5 w-full h-12 bg-ink-soft border border-line focus:border-paper outline-none px-3.5 text-paper transition-colors"
      />
    </label>
  )
}
